import { gql } from "@apollo/client";

export const GET_DOCUMENTOS = gql`
query documentoFac{
    documentoFac {
        idDocumentoFac,
        nombre
    }
  }
`;